


// Utility functions matching your code
export function safeArray(arr) {
  return Array.isArray(arr) ? arr : [];
}

export function shortText(text = "", max = 140) {
  if (!text) return "—";
  const truncated = text.length <= max ? text : text.slice(0, max - 1) + "…";
  return truncated;
}

export function formatShortText(text) {
  if (!text || text === "—") return text;
  let cleaned = text.replace(/\n/g, ' ');
  cleaned = cleaned.replace(/^\d+\.\s+/, '');
  const parts = cleaned.split('**');
  const elements = [];
  parts.forEach((part, index) => {
    if (index % 2 === 0) {
      if (part) elements.push(<span key={index}>{part}</span>);
    } else {
      if (part.trim()) {
        elements.push(
          <strong key={index} style={{ fontWeight: 600, color: '#1f2937' }}>
            {part}
          </strong>
        );
      }
    }
  });
  return <span>{elements}</span>;
}

export function formatDescription(text) {
  if (!text) return "—";
  const lines = text.split('\n');
  const elements = [];
  lines.forEach((line, lineIndex) => {
    if (!line.trim()) {
      elements.push(<br key={`br-${lineIndex}`} />);
      return;
    }
    const numberMatch = line.match(/^(\d+\.\s)/);
    let processedLine = line;
    let numberPrefix = null;
    if (numberMatch) {
      numberPrefix = numberMatch[1];
      processedLine = line.slice(numberPrefix.length);
    }
    const parts = processedLine.split('**');
    const lineElements = [];
    if (numberPrefix) {
      lineElements.push(
        <strong key={`${lineIndex}-num`} style={{ fontWeight: 700, color: '#111827' }}>
          {numberPrefix}
        </strong>
      );
    }
    parts.forEach((part, index) => {
      if (index % 2 === 0) {
        if (part) {
          lineElements.push(<span key={`${lineIndex}-${index}`}>{part}</span>);
        }
      } else {
        if (part.trim()) {
          lineElements.push(
            <strong key={`${lineIndex}-${index}`} style={{ fontWeight: 700, color: '#111827' }}>
              {part}
            </strong>
          );
        }
      }
    });
    elements.push(
      <div key={lineIndex} style={{ marginBottom: '0.5rem' }}>
        {lineElements}
      </div>
    );
  });
  return <div style={{ whiteSpace: 'pre-wrap' }}>{elements}</div>;
}